import $ from 'jquery';

/* ===============================================================
Woocommerce scripts
=============================================================== */
class NavigationCart {
    constructor() {
        // Singleton pattern - return existing instance if it exists
        if (NavigationCart.instance) {
            return NavigationCart.instance;
        }

        // Get button open
        this.btnOpen = $('.irantheme-woocommerce-cart-navigation-open');
        // Get wrapper body
        this.wrapper = $('#irantheme-wrapper');
        // Get irantheme navigation
        this.navigationCart = $('.irantheme-woocommerce-cart-navigation');
        // Get wrapper body mask
        this.wrapperMask = $('#irantheme-wrapper-mask');
        // Get wrapper cart
        this.wrapperList = this.navigationCart.find(
            '.irantheme-woocommerce-cart-navigation-wrapper',
        );
        // Get wrapper wishlist
        this.wrapperWishlist = this.navigationCart.find(
            '.irantheme-woocommerce-wishlist-navigation-wrapper',
        );
        this.toggleList = this.navigationCart.find(
            '.irantheme-woocommerce-cart-navigation-header-togglers-cart',
        );
        this.toggleWishlist = this.navigationCart.find(
            '.irantheme-woocommerce-cart-navigation-header-togglers-wishlist',
        );
        // Get close button
        this.btnClose = this.navigationCart.find(
            '.irantheme-woocommerce-cart-navigation-close',
        );
        this.btnAddToCart = $('.ajax_add_to_cart');
        this.preloader = this.navigationCart.find('.irantheme-preloader-abs');

        // Flag to prevent duplicate AJAX calls
        this._isLoading = false;
        this._isOpen = false;

        // Store instance
        NavigationCart.instance = this;

        this.events();
    }

    events() {
        const self = this;

        this.btnOpen.on('click', (e) => {
            e.preventDefault();
            this.open();
        });

        this.btnClose.on('click', () => {
            this.close();
        });

        this.wrapperMask.on('click', () => {
            this.close();
        });

        this.navigationCart.on(
            'click',
            '.irantheme-woocommerce-cart-navigation-list-item-remove-button',
            (e) => {
                let productId = $(e.currentTarget).data('product-id');
                this.removeItemFromCart(productId);
            },
        );

        // Handle quantity increase/decrease buttons
        this.navigationCart
            .find('.irantheme-woocommerce-cart-navigation-wrapper')
            .on('click', '.irantheme-quantity-btn', (e) => {
                e.preventDefault();
                e.stopPropagation();

                const button = $(e.currentTarget);
                const cartItemKey = button.data('cart-item-key');
                const isIncrease = button.hasClass('irantheme-quantity-plus');
                const actionType = isIncrease ? 'increase' : 'decrease';

                this.updateCartQuantity(cartItemKey, actionType);
            });

        // FIXED: Remove getAjaxCartItems() call from toggleList - it's already called in open()
        this.toggleList.on('click', () => {
            if (!this.toggleList.hasClass('active')) {
                this.toggleList.addClass('active');
                this.toggleWishlist.removeClass('active');
                this.wrapperList.show();
                this.wrapperWishlist.hide();
                // REMOVED: this.getAjaxCartItems(); // Already called in open()
            }
        });

        // Update cart total when items are added/removed
        $(document).on('added_to_cart removed_from_cart', function () {
            self.updateCartTotal();
        });
    }

    // Toggle nav
    open() {
        // Prevent opening if already open
        if (this._isOpen) {
            return;
        }

        this._isOpen = true;
        this.toggleList.addClass('active');
        this.toggleWishlist.removeClass('active');
        this.wrapperWishlist.hide();
        this.wrapperList.show();
        this.btnOpen.addClass('active');
        this.navigationCart.addClass('active');
        this.wrapperMask.fadeIn();
        this.getAjaxCartItems();
    }

    // Close nav
    close() {
        this._isOpen = false;
        this.btnOpen.removeClass('active');
        this.wrapper.removeClass('active');
        this.navigationCart.removeClass('active');
        this.wrapperMask.fadeOut();
    }

    // Count of wishlist items
    fetchCount() {
        if (iranthemeWoo.woocommerceIsActivate == 1) {
            var ajax_url = iranthemeWpData.adminAjax;
            $.ajax({
                url: ajax_url,
                type: 'post',
                data: {
                    action: 'fetch_count_items_from_cart',
                },
                dataType: 'html',
                beforeSend: (response) => {},
                success: (response) => {
                    setTimeout(function () {
                        if (response != '0') {
                            $('.irantheme-shopping-cart-count').text(response);
                            $('.irantheme-shopping-cart-count')
                                .parent()
                                .fadeIn();
                        } else {
                            $('.irantheme-shopping-cart-count').text(response);
                            $('.irantheme-shopping-cart-count')
                                .parent()
                                .fadeOut();
                        }
                    }, 1000);
                },
                complete: (response) => {},
                error: (error) => {
                    console.log(error.responseText);
                },
            });
        }
    }

    // Remove ajax item from cart
    removeItemFromCart(productId) {
        const ajax_url = iranthemeWpData.adminAjax;
        const self = this;

        $.ajax({
            url: ajax_url,
            type: 'post',
            data: {
                action: 'remove_item_from_cart',
                product_id: productId,
            },
            dataType: 'html',
            beforeSend: (response) => {
                this.preloader.addClass('active');
                this.wrapperList.html('');
            },
            success: (response) => {
                this.getAjaxCartItems(false);
                setTimeout(() => {
                    self.updateCartTotal();
                }, 500);
            },
            complete: (response) => {
                setTimeout(() => {
                    this.preloader.removeClass('active');
                }, 501);
                this.fetchCount();
            },
            error: (error) => {
                console.log(error.responseText);
            },
        });
    }

    // Get ajax cart items - FIXED with loading flag
    getAjaxCartItems(preloader = true) {
        // Prevent duplicate calls
        if (this._isLoading) {
            return;
        }

        if (iranthemeWoo.woocommerceIsActivate == 1) {
            this._isLoading = true;
            var ajax_url = iranthemeWpData.adminAjax;

            $.ajax({
                url: ajax_url,
                type: 'post',
                data: {
                    action: 'cart_list_items_navigation',
                },
                dataType: 'html',
                beforeSend: (response) => {
                    if (preloader) {
                        this.preloader.addClass('active');
                    }
                    this.wrapperList.html('');
                },
                success: (response) => {
                    this.wrapperList.append(response);
                },
                complete: (response) => {
                    this._isLoading = false;
                    if (preloader) {
                        this.preloader.removeClass('active');
                    }
                },
                error: (error) => {
                    this._isLoading = false;
                    console.log(error.responseText);
                },
            });
        } else {
            this.wrapperList.html('');
            let emptyTag =
                '<p class="irantheme-woocommerce-cart-navigation-wrapper-empty">متاسفانه افزونه ووکامرس فعال یا نصب نمی باشد.</p>';
            $(emptyTag).prependTo(this.wrapperList);
            this.preloader.removeClass('active');
        }
    }

    // Update cart quantity via AJAX
    updateCartQuantity(cartItemKey, actionType) {
        const ajax_url = iranthemeWpData.adminAjax;
        const self = this;

        const itemElement = $(`[data-cart-item-key="${cartItemKey}"]`).closest(
            '.irantheme-woocommerce-cart-navigation-list-item',
        );
        itemElement.addClass('irantheme-updating');

        $.ajax({
            url: ajax_url,
            type: 'post',
            data: {
                action: 'update_cart_quantity',
                cart_item_key: cartItemKey,
                action_type: actionType,
            },
            dataType: 'html',
            beforeSend: () => {
                const preloader =
                    '<div class="irantheme-item-preloader"><div class="irantheme-spinner"></div></div>';
                itemElement
                    .find('.irantheme-quantity-input-wrapper')
                    .append(preloader);
            },
            success: (response) => {
                if (response !== 'error') {
                    self.wrapperList.html(response);
                    self.fetchCount();
                    setTimeout(() => {
                        self.updateCartTotal();
                    }, 500);
                } else {
                    console.error('Failed to update quantity');
                }
            },
            complete: () => {
                itemElement.removeClass('irantheme-updating');
                itemElement.find('.irantheme-item-preloader').remove();
            },
            error: (error) => {
                console.error('Error:', error.responseText);
                itemElement.removeClass('irantheme-updating');
                itemElement.find('.irantheme-item-preloader').remove();
            },
        });
    }

    updateCartTotal() {
        const ajax_url = iranthemeWpData.adminAjax;
        $.ajax({
            url: ajax_url,
            type: 'POST',
            data: {
                action: 'get_cart_total_ajax',
            },
            beforeSend: () => {},
            success: (response) => {},
            complete: (response) => {},
            error: (error) => {
                console.error('Error:', error.responseText);
            },
        });
    }
}

export default NavigationCart;
